/**
 * Block Labels
 * 
 * Adds visual labels to Gutenberg blocks showing their name
 * Only visible when user is logged in
 */

( function( $ ) {
	'use strict';

	/**
	 * Check if user is logged in
	 * 
	 * @return {boolean} True if user is logged in
	 */
	function isUserLoggedIn() {
		return document.body.classList.contains( 'logged-in' );
	}

	/**
	 * Initialize block labels
	 */
	function initBlockLabels() {
		// Only run if user is logged in
		if ( ! isUserLoggedIn() ) {
			return;
		}

		// Find all blocks with data-block-label attribute
		const blocks = document.querySelectorAll( '[data-block-label]' );

		blocks.forEach( ( block ) => {
			const blockTitle = block.getAttribute( 'data-block-label' );
			const blockFile = block.getAttribute( 'data-block-file' );

			if ( ! blockTitle ) {
				return;
			}

			// Check if label already exists (prevent duplicates)
			if ( block.querySelector( '.block-label' ) ) {
				return;
			}

			// Create label element
			const label = document.createElement( 'div' );
			label.className = 'block-label';
			label.textContent = blockTitle;

			// If block file path exists (admin only), make it clickable
			if ( blockFile ) {
				label.classList.add( '-clickable' );
				label.style.cursor = 'pointer';
				label.setAttribute( 'title', 'Click to open in Cursor: ' + blockFile );
				
				label.addEventListener( 'click', function( e ) {
					e.preventDefault();
					e.stopPropagation();
					
					// Open file in Cursor using the cursor:// protocol
					const cursorUrl = 'cursor://file/' + blockFile;
					window.location.href = cursorUrl;
				} );
			}

			// Make sure block has position context
			const blockPosition = window.getComputedStyle( block ).position;
			if ( blockPosition === 'static' ) {
				block.style.position = 'relative';
			}

			// Add label to block
			block.appendChild( label );
		} );
	}

	// Initialize on DOM ready
	$( function() {
		initBlockLabels();
	} );

	// Re-initialize on window load (for any dynamically loaded content)
	$( window ).on( 'load', function() {
		initBlockLabels();
	} );

} )( jQuery );

